<ul class="app-payment-menu-items" nz-menu [nzMode]="'inline'" [nzSelectable]="false">
  <li nz-menu-item (click)="makePayment()" [nzDisabled]="(makePaymentEnabled$ | async) === false" data-cy="payment-menu-make-payment">
    <app-image name="add-menu"></app-image>
    <span translate>menu.main.payments.new</span>
  </li>

  @if ((pendingPaymentsVisible$ | async)) {
  <li
    nz-menu-item
    (click)="pendingPayments()"
    [nzDisabled]="(pendingPaymentsEnabled$ | async) === false"
    [ngClass]="{ 'pending-payments': (pendingOperationsCount$ | async) }"
  >
    @if ((pendingOperationsCount$ | async); as count) {
    <div class="icon-with-badge">
      <app-image name="pending"></app-image>
      <span class="badge">{{ count }}</span>
    </div>
    } @if ((pendingOperationsCount$ | async) === 0) {
    <app-image name="pending"></app-image>
    }
    <span translate>menu.main.payments.pending</span>
  </li>
  } @if (!isScreenSizeEqOrLessThanSM) { @if (importPaymentsVisible$ | async) {
  <li nz-menu-item (click)="importPayments()" [nzDisabled]="(importPaymentsEnabled$ | async) === false">
    <app-image name="import"></app-image>
    <span translate>menu.main.payments.import</span>
  </li>
  } } @if (scheduledPaymentsVisible$ | async) {
  <li nz-menu-item (click)="scheduledPayments()" [nzDisabled]="(scheduledPaymentsEnabled$ | async) === false">
    <app-image name="scheduled"></app-image>
    <span translate>menu.main.payments.scheduled</span>
  </li>
  } @if (paymentBeneficiariesVisible$ | async) {
  <li nz-menu-item (click)="paymentBeneficiaries()" [nzDisabled]="(paymentBeneficiariesEnabled$ | async) === false" data-cy="payment-menu-recipients">
    <app-image name="recipients"></app-image>
    <span translate>menu.main.payments.recipients</span>
  </li>
  }
</ul>
